<template>
  <div class="currentInfo">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  export default {
    name: 'currentInfo',
    computed: {
      columnList() {
        return [
          { type: 'seq', title: this.$t('table.index'), width: 60 }, // 序号
          {
            field: 'futuCode',
            title: this.$t('futuresStrategy.futuresStrategyList.table.futuCodeBasis'),
          }, // 商品代码
          {
            field: 'stockName',
            width: 120,
            title: this.$t('futuresStrategy.futuresStrategyList.table.stockNameBasis'),
          }, // 商品名称
          {
            field: 'moneyType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.moneyType'),
          }, // 币种
          {
            field: 'combiHoldType',
            title: this.$t('futuresStrategy.futuresStrategyList.table.combiHoldType'),
          }, // 持仓方向
          {
            field: 'squarePrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.squarePrice'),
          }, //市场价格
          {
            field: 'averageOpenPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageOpenPrice'),
          }, //开仓价格
          {
            field: 'openAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.openAmount'),
          }, // 开仓数量
          {
            field: 'sumAverageOpenPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageOpenPrice'),
            formatter: this.formatterBaseInfo,
          }, // 累计开仓均价
          {
            field: 'sumOpenAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumOpenAmount'),
            formatter: this.formatterBaseInfo,
          }, //累计开仓数量
          {
            field: 'averageHoldPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageHoldPrice'),
            formatter: this.formatterMarginAmount,
          }, // 持仓均价
          {
            field: 'currentAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.currentAmount'),
            formatter: this.formatterMarginAmount,
          }, //持仓数量
          {
            field: 'averageDropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.averageDropPrice'),
          }, // 平仓均价
          {
            field: 'dropAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.dropAmount'),
          }, // 平仓数量
          {
            field: 'sumAverageDropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumAverageDropPrice'),
          }, // 累计平仓均价
          {
            field: 'sumDropAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.sumDropAmount'),
          }, // 累计平仓数量
          {
            field: 'holdIncomeFloat',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdIncomeFloat'),
          }, // 浮动盈亏
          {
            field: 'actualIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.actualIncome'),
          }, // 实现盈亏
          {
            field: 'initDate',
            title: this.$t('futuresStrategy.futuresStrategyList.table.initDateHold'),
          }, // 持仓更新日期
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {},
  };
</script>
<style lang="scss" scoped>
  .currentTitle {
    line-height: 15px;
    height: 35px;
    margin-top: 20px;
  }
</style>
